import { Button } from "@chakra-ui/button";
import {
  Flex,
  Text,
  Box,
  Spacer,
  Input,
  FormLabel,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import React, { useMemo } from "react";
import { useDropzone } from "react-dropzone";
import "../Programs.scss";

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#eeeeee",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out",
  margin: "2rem 0",
  height: "120px",
  justifyContent: "center",
};

const activeStyle = {
  borderColor: "#2196f3",
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff1744",
};
const CreateHandout = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [files, setFiles] = React.useState({
    title: "",
  });
  const [data, setData] = React.useState([]);
  const {
    isDragActive,
    isDragAccept,
    isDragReject,
    getRootProps,
    getInputProps,
  } = useDropzone({
    onDrop: (acceptedFiles) => {
      setFiles((prevFiles) =>
        acceptedFiles.reduce(
          (acc, file) => ({
            ...acc,
            file: {
              name: file.name,
              fileUrl: URL.createObjectURL(file),
            },
          }),
          prevFiles
        )
      );
    },
    // accept: ".doc",
  });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFiles({
      ...files,
      [name]: value,
    });
  };

  const handleClick = () => {
    setData((prev) => [...prev, files]);

    console.log(files);
    setFiles({
      ...files,
      title: "",
      file: {},
    });
  };

  console.log(data);
  return (
    <div>
      <Flex
        px="7"
        py="6"
        borderBottom="1px solid rgb(218, 224, 234)"
        alignItems="center"
      >
        <Box>
          <Text color="#00A2E7" sx={{ fontWeight: "bold" }}>
            Create Handout
          </Text>
        </Box>
        <Spacer />
        <Box>
          <Button py="4" px="8" bg="blue.400" color="white">
            {" "}
            Save
          </Button>
        </Box>
      </Flex>

      <Box width="80%" pl="7" mt="5">
        {data.map((data, idx) => (
          <Flex
            justifyContent="space-between"
            my={3}
            className="singleCurriculum"
            p={3}
            key={idx}
          >
            <h1>{data.title}</h1>
            <a href={data.file?.fileUrl}>{data.file?.name}</a>
          </Flex>
        ))}
      </Box>
      {isOpen && (
        <Modal isOpen={isOpen} onClose={onClose} height="80%">
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Program List</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Box width="80%" pl="7" mt="5">
                <h2>These will show up as documents to your trainees</h2>
                <Box mt={6}>
                  <FormLabel htmlFor="title">Title</FormLabel>
                  <Input
                    variant="filled"
                    id="title"
                    type="text"
                    name="title"
                    placeholder="Enter Title"
                    size="lg"
                    onChange={handleChange}
                    value={files.title}
                  />
                </Box>
                <section className="file-certificate">
                  <div {...getRootProps({ style })}>
                    <input
                      {...getInputProps()}
                      type="file"
                      //   onChange={handleFileUpload}
                    />
                    <p>Click to select files or drag files to upload</p>
                  </div>
                  <aside>
                    <h4>Files</h4>
                    {/* <ul>{file.file}</ul> */}
                    <p>{files.file?.name}</p>
                  </aside>
                </section>
                <Button
                  py="4"
                  px="8"
                  bg="blue.400"
                  color="white"
                  onClick={handleClick}
                >
                  {" "}
                  Save
                </Button>
              </Box>
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
      <Box>
        {data.length === 0 && (
          <Text textAlign="center" color="blue">
            Here you find handouts you create
          </Text>
        )}
        <Box textAlign="end" width="80%" pl="7" mt="5">
          <Button bg="#213C5C" color="white" mr={3} onClick={onOpen}>
            Create Handout
          </Button>
        </Box>
      </Box>
    </div>
  );
};

export default CreateHandout;
